import React from "react";
import * as QueryString from "query-string"
import { Locale } from "../../core/api/model";
import { ContactPage, ContactPageRecipientType, ContactPageType } from "../components";
import NotFound from "../../core/errors/not-found";

export interface ContactProps {
  locale: Locale;
  showErrorModal: (title: string, description: string, raw?: any) => void;
}

export const Contact = (props: ContactProps) => {
  const params = QueryString.parse(window.location.search);
  // @TODO REFACTORING
  let recipientType = ContactPageRecipientType.Undefined;
  if (params['recipientType'] === ContactPageRecipientType.Participant) {
    recipientType = ContactPageRecipientType.Participant;
  } else if (params['recipientType'] === ContactPageRecipientType.Corporation) {
    recipientType = ContactPageRecipientType.Corporation;
  }
  const recipientId: number = Number(params['recipientId']);

  if (Number.isNaN(recipientId) || recipientType === ContactPageRecipientType.Undefined) {
    return <NotFound />
  }

  return (
    <ContactPage
      locale={props.locale}
      type={ContactPageType.General}
      recipientType={recipientType}
      recipientId={recipientId}
      showErrorModal={props.showErrorModal}
    />
  );
};
